export const Report = {
    path: '/report',
    name: 'report',
    component: () => import('./Report.vue'),
    meta: {
        title: '事件上报'
    }
}

export const eventList = {
    path: '/eventList',
    name: 'eventList',
    component: () => import('./eventList.vue')
}

export const reportDetail = {
    path: '/reportDetail',
    name: 'reportDetail',
    component: () => import('./reportDetail.vue'),
    meta: {
        title: '上报事件'
    }
}

export const sendOrder = {
    path: '/sendOrder',
    name: 'sendOrder',
    component: () => import('./sendOrder.vue'),
    meta: {
        title: '派单'
    }
}